import { useContext } from 'react';

import { cn } from '@components/primitives/utilities';

import { DiagramContext } from '.';

import css from './Nodes.module.css';

export default function DiagramNodes({ children, className }) {
  const { direction } = useContext(DiagramContext);

  return (
    <div data-direction={direction} className={cn(css.nodes, className)}>
      {children}
    </div>
  );
}
